// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts'`', but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

var storageDevelopment: 'https://firebasestorage.googleapis.com/v0/b/bigadvice-development.appspot.com/o/files%2F';
var storageLive: 'https://firebasestorage.googleapis.com/v0/b/big-advice.appspot.com/o/files%2F';

export const environment = {
  production: true,
  development: true,
  storagePath: 'https://firebasestorage.googleapis.com/v0/b/bigadvice-development.appspot.com/o/files%2F',
  domainName: 'https://bigadvice.com/',
  badWords: [
    'götüne girsin', 'hepinizin amına koyayım', 'hepinizin hamına koyayım', 'amına koyayım', 'amk', 'aşağılık', 'ananı bacını sikeyim',
    'ak parti', 'akpci', 'akpli', 'akparti',
    'fuck you', 'amq', 'amuş', 'amını', 'anana', 'ananın amı', 'ananı sikiyim', 'apocu', 'apocular', 'allahını sikeyim', 'ağzına sıçayım',
    'ağzını sikeyim', 'ağzını yüzünü sikeyim', 'anal', 'anüs', 'amık', 'ağzını yrtarım', 'amcık hoşafı', 'am kafa', 'aptal', 'angut',
    'at siki', 'bağnaz', 'bdp', 'bok', 'boğazlamak', 'bacını sikeyim', 'bacını sikiyim', 'cemaati', 'cemaatçi', 'chp', 'cünup',
    'deist', 'deizm', 'daşşak', 'dinini sikeyim', 'dtk', 'dtp', 'dalyarak', 'dangalak', 'dallama', 'denyo', 'dümbük', 'dingil', 'ekber',
    'eşoğlueşek', 'eşek oğlu eşek', 'elini sikeyim', 'eşeğin siki', 'eşşeğin siki', 'fahişe', 'faşist', 'folloş', 'fak', 'fuck',
    'feto', 'fetocular', 'fetö', 'godoş', 'götüne', 'götünü sikeyim', 'götünden atma', 'götü', 'gavat', 'gerzek', 'gavur dölü',
    'götveren', 'gerizekalı', 'hasiktir', 'hassiktir', 'hamına', 'hırbo', 'hepinizi sikiyim', 'a.q', 'aq',
    'hepinizi sikerim', 'hödük', 'hıyar', 'hırtapoz', 'ibne', 'ipne', 'it oğlu it', 'it', 'sikeyim', 'amına', 'amcık', 'am', 'akp', 'cemaat', 'göt', 'döl',
    'eşek'
  ],
  alphabet: ['A', 'B', 'C', 'Ç', 'D', 'E', 'F', 'G', 'H', 'I', 'İ', 'J', 'K', 'L', 'M', 'N', 'O', 'Ö', 'P', 'R', 'S', 'Ş', 'T', 'U', 'Ü', 'V', 'Y', 'Z'],
  jobs: ["Antropolog", "Arkeolog", "Asker", "Aşçı", "Avukat", "Bankacı", "Bekçi /Zabıta", "Belediye çalışanı", "Berber / Kuaför", "Bilgisayar programcısı",
    "Biyolog", "Çiftçi/Ziraatçı", "Danışman", "Dekoratör", "Desinatör", "Diğer", "Din Adamı", "Diş hekimi", "Doktor", "Eczacı",
    "Emlak Komisyoncusu", "Esnaf / Zanaatkar", "Ev Hanımı", "Fotomodel", "Garson / Servis elemanı", "Gazeteci", "Girişimci", "Gümrük Komisyoncusu", "Güvenlik görevlisi",
    "Güzellik uzmanı", "Hakim / Savcı", "Hemşire", "Hizmetli", "İşçi", "İtfayeci", "Kalifiye işçi / Usta", "Kaptan", "Kasap", "Kaymakam / Vali",
    "Kimyager", "Konsolos / Büyükelçi", "Kuyumcu", "Laborant", "Madenci", "Mali müşavir", "Manken", "Memur", "Milletvekili", "Mimar", "Modelist",
    "Müfettiş", "Muhasebecı", "Mühendis", "Müteahhit", "Nakliyeci", "Noter", "Öğretim Görevlisi", "Öğretmen", "Pazarlama Uzmanı",
    "Pazarlama ve satış elemanı", "Pilot", "Polis", "Psikolog", "Rehber", "Reklamcı", "Sağlık hizmetlisi", "Sanatçı", "Sanayici", "Sekreter", "Serbest Meslek", "Sigortacı",
    "Sistem Analisti", "Şoför", "Sosyolog", "Sporcu", "Stilist", "Teknik ressam", "Teknisyen", "Tercüman", "Terzi", "Tüccar", "Turizmci",
    "TV ve radyo çalışanı Veteriner", "Üst Düzey Yönetici", "Veteriner",
    "Yazar / Şair"],
  categoriesModel: [
    // {
    //   "name": "Anne, Bebek & Oyuncak",
    //   "uniqueName": "anne_bebek_ve_oyuncak", anne bebek oyuncak,kültür sanat,turizm otomativ diğer
    //   "image": "anne_bebek_ve_oyuncak.png"
    // },
    {
      "name": "Banka & Sigortacılık Hizmetleri",
      "uniqueName": "banka_ve_sigortacilik_hizmetleri",
      "image": "bankasigortacılık.svg"
    },
    {
      "name": "Beyaz Eşya & Elektrikli Ev Aletleri",
      "uniqueName": "beyaz_esya_ve_elektrikli_ev_aletleri",
      "image": "beyazesya.svg"
    },
    {
      "name": "E-Ticaret Siteleri",
      "uniqueName": "eticaret_siteleri",
      "image": "eticaret.svg"
    },
    {
      "name": "Ev, Yaşam & Ofis",
      "uniqueName": "ev_yasam_ve_ofis",
      "image": "evyasam.svg"
    },
    {
      "name": "Moda, Giyim & Aksesuar",
      "uniqueName": "moda_giyim_ve_aksesuar",
      "image": "modagiyim.svg"
    },
    {
      "name": "Gıda & Hızlı Tüketim",
      "uniqueName": "gida_ve_hizli_tuketim",
      "image": "gıdaperakende.svg"
    },
    {
      "name": "İnternet & Telekomünikasyon",
      "uniqueName": "internet_ve_telekomunikasyon",
      "image": "internettelekominikasyon.svg"
    },
    {
      "name": "Teknoloji & Elektronik",
      "uniqueName": "teknoloji_ve_elektronik",
      "image": "teknolojielektronik.svg"
    },
    // {
    //   "name": "Kültür, Sanat, Müzik & Medya",
    //   "uniqueName": "kultur_sanat_muzik_ve_medya",
    //   "image": "kultur_sanat_muzik_ve_medya.png"
    // },
    // {
    //   "name": "Turizm",
    //   "uniqueName": "turizm",
    //   "image": "turizm.png"
    // },
    // {
    //   "name": "Otomotiv & Motosiklet",
    //   "uniqueName": "otomotiv_ve_motosiklet",
    //   "image": "otomotiv_ve_motosiklet.png"
    // },
    // {
    //   "name": "Sağlık, Güzellik & Kozmetik",
    //   "uniqueName": "saglik_guzellik_ve_kozmetik",
    //   "image": "saglıkgüzellik.svg"
    // }
    // {
    //   "name": "Diğer",
    //   "uniqueName": "diger",
    //   "image": "diger.png"
    // }
  ],
  categories2Model: [
    // {
    //   "name": "Spor & Aktif Yaşam",
    //   "uniqueName": "spor_ve_aktif_yasam",
    //   "image": "sporaktifyasam.svg"
    // },

    // {
    //   "name": "Ulaştırma & Lojistik",
    //   "uniqueName": "ulastirma_ve_lojistik",
    //   "image": "ulastırmalojistik.svg"
    // },

  ],
  emojis: [
    {
      "emojis": [
        [
          "😄",
          "smile"
        ],
        [
          "😊",
          "blush"
        ],
        [
          "😉",
          "wink"
        ],
        [
          "😍",
          "heart_eyes"
        ],
        [
          "😳",
          "flushed"
        ],
        [
          "😌",
          "relieved"
        ],
        [
          "😩",
          "weary"
        ],
        [
          "😱",
          "scream"
        ],
        [
          "😡",
          "rage"
        ],
        [
          "💔",
          "broken_heart"
        ],
        [
          "💖",
          "sparkling_heart"
        ],
        [
          "😒",
          "unamused"
        ], [
          "💯",
          "100"
        ],
        [
          "👍",
          "+1"
        ],
        [
          "👎",
          "-1"
        ],
        [
          "👌",
          "ok_hand"
        ],
        [
          "✌",
          "v"
        ],
        [
          "👏",
          "clap"
        ],
        [
          "💕",
          "two_hearts"
        ],
        [
          "🔥",
          "fire"
        ],
        [
          "😏",
          "smirk"
        ],
        [
          "🙏",
          "pray"
        ], [
          "☀",
          "sunny"
        ],
        [
          "💪",
          "muscle"
        ], [
          "😌",
          "relieved"
        ], [
          "🙌",
          "raised_hands"
        ], [
          "👊",
          "facepunch"
        ], [
          "🎉",
          "tada"
        ]
      ],
      "name": "People",
      "icon": ["😄", "smile"]
    }
  ]
};




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/environments/environment.ts